export default __webpack_public_path__ + "static/media/59.bcddbb0f.jpg";